import React from "react";
import { bandColor, classNames } from "../lib/utils";

export default function PerformanceBadge({ band, score, className = "" }) {
  if (!band || band === "No Data") {
    return <span className={classNames("inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium border", "bg-slate-100 text-slate-600 border-slate-200", className)}>No Data</span>;
  }
  return (
    <span className={classNames("inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-xs font-medium border", bandColor(band), className)}>
      {typeof score === "number" && <span className="font-bold">{score.toFixed(2)}</span>}
      <span>{band}</span>
    </span>
  );
}
